import { render, staticRenderFns } from "./Indication.vue?vue&type=template&id=62d598fa"
import script from "./Indication.vue?vue&type=script&lang=js"
export * from "./Indication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports